module.exports = __webpack_public_path__ + "img/share.539c9f9a.svg";